<template>
  <div class="fill-height d-flex flex-column" :style="$vuetify.breakpoint.mdAndDown && ' background: #F6F9FC;'">
    <HeaderJourney @goBack="goBack($event)" :state="state"/>
    <div class="journey-body fill-height flex-grow-1 d-flex flex-column">
      <v-row v-if="showSeekBar" justify="center" class="journey-progress-row flex-grow-0">
        <v-col cols="12" md="8" :lg="progressColLg" class="py-0">
          <SeekBar/>
        </v-col>
      </v-row>
      <div class="fill-height flex-grow-1" v-if="$vuetify.breakpoint.mdAndUp">
      <template v-if="state == 'matchMaking'">
        <div class="mt-4">
          <div class="contextArea">
            <!-- Show button when user is logged in but doesn't have a doctor -->
            <v-row v-if="isLoggedIn && !hasDoctor && !initialAnswerRecord" class="flex-grow-1" justify="center"
                   :class="$vuetify.breakpoint.mdAndUp && 'mt-10'">
              <v-col cols="12" md="8" lg="6">
                <div class="noDoctorSection text-center pa-5">
                  <div class="noDoctorIcon mb-4">
                    <v-icon size="64" color="#d1dcff">mdi-account-circle-outline</v-icon>
                  </div>
                  <div class="noDoctorTitle mb-3">
                    در حال حاضر درمانگری برای شما انتخاب نشده است
                  </div>
                  <div class="noDoctorDesc mb-6">
                    برای شروع فرآیند انتخاب درمانگر مناسب، روی دکمه زیر کلیک کنید
                  </div>
                  <v-btn
                      class="startJourneyBtn"
                      color="#39C990"
                      elevation="0"
                      large
                      @click="startFlow"
                  >
                    شروع فرآیند انتخاب درمانگر
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row class="flex-grow-1 " justify="center" :class="$vuetify.breakpoint.mdAndUp && 'mt-10' " v-else>
              <v-col cols="12" md="8" lg="4">
                <!--              <MatchMaking @excludeUser="excludeUser" @changeStateFlow="changeStateFlow($event)"-->
                <!--                           @setTherapists="setTherapists($event)"-->
                <!--                           @changeStep="changeStep($event)"/>-->
                <MatchMakingTestUserFlow
                    @updateFlowState="updateFlowState"
                    @restartTest="restartTest"
                    :language="$vuetify.rtl ? 'fa' : 'en'"
                    :call-change-in-option="callChangeInOption"
                    @matchMakingTestEnd="matchMakingTestEnd($event)"
                    :prev="prev"
                    class="mt-2"
                    :initial-answer-record="initialAnswerRecord"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </template>
      <template v-else-if="state == 'exclude'">
        <ExcludePage/>
      </template>
      <template v-else-if="state == 'select_time'">
        <SelectedTime :selectd_time="selected_time" @changeStateFlow="changeStateFlow($event)"
                      @selectTime="selectTimeWithOutState($event)"
                      :therapist="selectedTherapist"/>
      </template>
      <template v-else-if="state == 'suggest_doctors'">
        <div :class="$vuetify.breakpoint.mdAndUp && 'mt-10' ">
          <div class="contextArea">
            <v-fade-transition mode="out-in">
              <div key="1" v-if="showSuggestDoctorsLoading">
                <div class="text-center mt-10">
                  <lottie-animation
                      ref="anim"
                      :animationData="require('../../assets/lottie/searching.json')"
                      :loop="true"
                      :autoPlay="true"
                      style="width: 238px;margin: 0px auto"
                  />
                  <div class="titleLoading">
                    در حال یافتن بهترین درمانگران متناسب با شما...
                  </div>
                  <div class="descLoading">
                    تا چند لحظه دیگر، نتیجه بررسی به شما ارائه میشود
                  </div>
                  <SuggestDoctorLoadingTestimonials/>
                </div>
              </div>
              <SuggestedDoctor key="2" @selectDoctor="selectDoctor($event)" @changeStateFlow="changeStateFlow($event)"
                               v-else-if="showSuggestDoctorList"
                               :therapists="therapists"/>
              <SuggestDoctorEmptyState key="3" @changeStateFlow="changeStateFlow($event)" v-else/>
            </v-fade-transition>
          </div>
        </div>
      </template>
      <template v-else-if="state == 'auth'">
        <AuthJourney @getMatchTherapist="getMatchTherapist" @changeStateFlow="changeStateFlow($event)"/>
      </template>
      <template v-else-if="state == 'select_package'">
        <SelectPacakge 
          v-if="selected_time && selectedTherapist" 
          :flow="flow" 
          @backToTime="backToTime" 
          :selected_time="selected_time"
          @changeStateFlow="changeStateFlow($event)"
          @selectTime="selectTime($event)"
          @restartTest="restartTest"
          :therapist="selectedTherapist"/>
      </template>
      </div>
      <div v-else class="mobilecontext flex-grow-1">
      <div class="contextArea  fill-height">
        <template v-if="state == 'matchMaking'">
          <div class="contextArea fill-height white ">

            <!--            <MatchMaking @excludeUser="excludeUser" @changeStateFlow="changeStateFlow($event)"-->
            <!--                         @setTherapists="setTherapists($event)"-->
            <!--                         @changeStep="changeStep($event)"/>-->
            <MatchMakingTestUserFlow
                @updateFlowState="updateFlowState"
                @restartTest="restartTest"
                @changeStateFlow="changeStateFlow"
                :language="$vuetify.rtl ? 'fa' : 'en'"
                :call-change-in-option="callChangeInOption"
                @matchMakingTestEnd="matchMakingTestEnd($event)"
                :prev="prev"
                :initial-answer-record="initialAnswerRecord"
            />

          </div>
        </template>
        <template v-else-if="state == 'exclude'">
          <ExcludePage/>
        </template>
        <template v-else-if="state == 'select_time'" class="">
          <SelectedTime :selectd_time="selected_time" @changeStateFlow="changeStateFlow($event)"
                        @selectTime="selectTimeWithOutState($event)"
                        :therapist="selectedTherapist"/>
        </template>
        <template v-else-if="state == 'suggest_doctors'">
          <div class="contextArea fill-height white" style="padding-top: 20px">
            <v-fade-transition>
              <template v-if="showSuggestDoctorsLoading">
                <div class="d-flex justify-center flex-column mt-8">
                  <div class="text-center  fill-height ">
                    <lottie-animation
                        ref="anim"
                        :animationData="require('../../assets/lottie/searching.json')"
                        :loop="true"
                        :autoPlay="true"
                        style="width: 238px;margin: 0px auto"
                    />
                    <div class="titleLoading">
                      در حال یافتن بهترین درمانگران متناسب با شما...
                    </div>
                    <div class="descLoading">
                      تا چند لحظه دیگر، نتیجه بررسی به شما ارائه میشود
                    </div>
                    <SuggestDoctorLoadingTestimonials/>
                  </div>
                </div>
              </template>

              <SuggestedDoctor
                  @selectDoctor="selectDoctor($event)"
                  :selectd_time="selected_time" @changeStateFlow="changeStateFlow($event)"
                  v-else-if="showSuggestDoctorList"
                  :therapists="therapists"/>

              <SuggestDoctorEmptyState @changeStateFlow="changeStateFlow($event)" v-else/>
            </v-fade-transition>


          </div>
        </template>
        <template v-else-if="state =='auth'">
          <AuthJourney @getMatchTherapist="getMatchTherapist" @changeStateFlow="changeStateFlow($event)"/>
        </template>
        <template v-else-if="state == 'select_package'">
          <SelectPacakge 
            v-if="selected_time && selectedTherapist" 
            :flow="flow" 
            @backToTime="backToTime" 
            :selected_time="selected_time"
            @changeStateFlow="changeStateFlow($event)"
            @selectTime="selectTime($event)"
            @restartTest="restartTest"
            :therapist="selectedTherapist"/>
        </template>
      </div>
    </div>
    </div>

    <div class="footerArea" v-if="$vuetify.breakpoint.mdAndUp">
      <div class="text-center flex-grow-1">
        <b>
          رو ب رو
        </b>
        |
        پلتفرم تخصصی مشاوره آنلاین روانشناسی
      </div>
    </div>


    <SimiaWelcomeModal v-model="simiaWelcomeModal"/>

    <v-dialog v-model="loginModal" width="520" persistent>
      <div class="white loginModal text-center">
        <img src="../../assets/image/user-journey/computer-login-concept-illustration_114360-7892.jpg" width="50%"
             alt="">
        <div class="titleAuthModal">
          تا اینجا عالی پیش رفتید،برای قدم بعدی آماده اید؟
        </div>
        <div class="descAuthModal">
          جهت مشاهده نتیجه تحلیل و معرفی تراپیست های مناسب شما، کافیست وارد شوید
        </div>
        <div class="doneBtn mt-5">
          <v-btn class="nextBtn" color="#30A778" block id="confirm_btn" elevation="0"
                 @click="state = 'auth';loginModal = false">
            ورود و مشاهده درمانگران مناسب من
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
/*eslint-disable*/
import MatchMakingTestUserFlow from "@/components/MatchMaking/MatchMakingTestUserFlow.vue";
import MatchMaking from "@/components/UserJourney/MatchMaking.vue";
import SeekBar from "@/components/UserJourney/SeekBar.vue";
import SuggestedDoctor from "@/components/UserJourney/SuggestedDoctor.vue";
import SelectedTime from "@/components/UserJourney/SelectedTime.vue";
import HeaderJourney from "@/components/UserJourney/HeaderJourney.vue";
import AuthJourney from "@/components/UserJourney/AuthJourney.vue";
import SelectPacakge from "@/components/UserJourney/SelectPacakge.vue";
import SuggestDoctorEmptyState from "@/components/UserJourney/suggestDoctorEmptyState.vue";
import SuggestDoctorLoadingTestimonials from "@/components/UserJourney/SuggestDoctorLoadingTestimonials.vue";
import ExcludePage from "@/components/UserJourney/ExcludePage.vue";
import {mapGetters} from "vuex";
import LottieAnimation from "lottie-web-vue";
import PreSessionBox from "@/components/UserJourney/PreSessionBox.vue";
import EventsMixins from "@/mixins/EventsMixins";
import SimiaWelcomeModal, {shouldShowSimiaWelcome} from "@/components/UserJourney/SimiaWelcomeModal.vue";
import {BOOKING_ACTION, parseBookingIntent} from "@/booking";

export default {
  mixins: [EventsMixins],
  components: {
    SimiaWelcomeModal,
    PreSessionBox,
    LottieAnimation,
    MatchMakingTestUserFlow,
    ExcludePage,
    SuggestDoctorEmptyState,
    SuggestDoctorLoadingTestimonials,
    SelectPacakge, AuthJourney, HeaderJourney, SelectedTime, SuggestedDoctor, SeekBar, MatchMaking
  },
  data() {
    return {
      loginModal: false,
      simiaWelcomeModal: false,
      prev: false,
      match_additional_data: {},
      callChangeInOption: false,
      seekbarVisibility: true,
      state: 'matchMaking',
      currentStep: 1,
      selectedTherapist: {},
      therapists: null,
      suggestDoctorsPending: false,
      token: null,
      should_exclude: false,
      selected_time: null,
      initialAnswerRecord: null,
      timezone: null,
      flow: null,
      historyNavigation: false,
      journeySuggestResultTracked: false,
      pendingBookingIntent: null,
    }
  },
  computed: {
    ...mapGetters({
      'isLoggedIn': 'getIsLoggedIn',
      'profile': 'getProfile',
    }),
    hasDoctor() {
      return this.profile?.assignedDoctor && Array.isArray(this.profile.assignedDoctor) && this.profile.assignedDoctor.length > 0
    },
    derivedCurrentStep() {
      if (this.state == 'init' || this.state == 'matchMaking') {
        return 1
      } else if (this.state == 'auth') {
        return 2
      } else if (this.state == 'suggest_doctors') {
        return 3
      }
    },
    showSuggestDoctorsLoading() {
      return this.state === 'suggest_doctors' &&
          (this.suggestDoctorsPending || this.therapists == null)
    },
    showSuggestDoctorList() {
      return Array.isArray(this.therapists)
          && this.therapists.some((therapist) => therapist && therapist.id)
    },
    showSeekBar() {
      return !(this.state === 'select_time' && this.$vuetify.breakpoint.mdAndDown)
    },
    progressColLg() {
      if (this.state === 'matchMaking') return 4
      if (this.state === 'auth') return 4
      return 6
    },
  },
  methods: {
    matchMakingTestEnd(data) {
      localStorage.removeItem('psychology_field_id')
      this.match_additional_data = data || {}
      localStorage.removeItem('matchmaking_gender')
      delete this.match_additional_data.gender
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 80)
      localStorage.setItem('match_additional_data', JSON.stringify(this.match_additional_data))
      if (this.isLoggedIn) {
        this.getMatchTherapist();
        this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 85)
      } else {
        // this.loginModal = true
        this.state = 'auth'
      }
    },
    goBack() {
      if (window.history.length > 1) {
        window.history.back()
      }
    },
    getStepQueryForState(state) {
      const pages = {
        matchMaking: 'matchmaking',
        auth: 'auth',
        suggest_doctors: 'suggested_doctor',
        select_time: 'select_time',
        select_package: 'select_packages',
      }
      return pages[state] || 'matchmaking'
    },
    pushJourneyHistory() {
      const step = this.getStepQueryForState(this.state)
      window.history.pushState({journeyStep: this.state}, '', `?step=${step}`)
    },
    handlePopState(event) {
      this.historyNavigation = true

      if (this.state === 'matchMaking') {
        this.$emitEvent('backInMatchMaking')
      } else if (event.state?.journeyStep) {
        if (this.state === 'suggest_doctors') {
          this.suggestDoctorsPending = false
        }
        this.state = event.state.journeyStep
      }

      this.$nextTick(() => {
        this.historyNavigation = false
      })
    },
    excludeUser() {
      this.state = 'exclude'
      console.log('excludeexcludeexcludeexcludeexclude')
    },
    backToTime() {
      this.state = 'select_time'
    },
    selectTime(time) {
      console.log('this. is a ', time)
      this.selected_time = time
      // Wait 1 second before loading select package component
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.state !== 'select_package') {
            this.state = 'select_package'
          }
        })
      }, 1000)
    },
    selectTimeWithOutState(time) {
      this.selected_time = time
    },

    selectDoctor(therapist, options = {}) {
      const track = options.track !== false
      this.selectedTherapist = therapist
      this.state = 'select_time'
      if (track) {
        const doctorName = (therapist && therapist.user && therapist.user.full_name)
          || (therapist && therapist.full_name)
          || ''
        this.sendJourneyTrkEvent('therapist_selection', {
          state: 'journey_book',
          therapist_id: therapist && therapist.id,
          therapist_name: doctorName,
        })
      }
    },
    selectDoctorForWithoutState(therapist) {
      this.selectedTherapist = therapist
    },
    getAssignedDoctor() {
      const assigned = this.profile && this.profile.assignedDoctor
      if (!assigned) {
        return null
      }
      if (Array.isArray(assigned)) {
        return assigned.length > 0 ? assigned[0] : null
      }
      return assigned
    },
    applyBookingIntent() {
      const intent = this.pendingBookingIntent
      if (!intent || !intent.action) {
        return
      }

      if (intent.action === BOOKING_ACTION.RESUME) {
        this.pendingBookingIntent = null
        return
      }

      if (intent.action === BOOKING_ACTION.SELECT_TIME) {
        const doctor = this.getAssignedDoctor()
        if (doctor && doctor.id && this.token) {
          this.changeStateFlow({state: 'select_time', doctor_id: doctor.id})
        }
      }

      this.pendingBookingIntent = null
    },
    changeStep(step) {
      this.currentStep = step
    },
    returnBack() {
      if (this.currentStep != 1) {
        this.$emitEvent('changeStepMatchmaking', (this.currentStep - 1))
      } else {
        window.location = 'https://simiaroom.com'
      }
    },
    persistRefferIdFromQuery() {
      let id = this.$route.query.reffer_id
      if (Array.isArray(id)) {
        id = id[0]
      }
      if (id == null || String(id).trim() === '') {
        try {
          id = new URLSearchParams(window.location.search).get('reffer_id')
        } catch (e) {
          id = null
        }
      }
      if (id != null && String(id).trim() !== '') {
        localStorage.setItem('reffer_id', String(id).trim())
      }
    },
    startFlow() {
      this.persistRefferIdFromQuery()
      localStorage.removeItem('psychology_field_id')
      const body = {
        timezone: this.prepareDefaultTimezone(),
      }
      const reffer = localStorage.getItem('reffer_id')
      if (reffer) {
        body.reffer = reffer
      }
      this.requesting('setSession', 'startFlow', {}, body).then((resp) => {


        this.flow = resp.data.flow

        this.token = resp.data.flow.token
        localStorage.setItem('set_session_token', this.token,)
        if (resp && resp.data && resp.data.answer_record) {
          this.initialAnswerRecord = resp.data.answer_record
          this.state = 'matchMaking'
        }
        this.applyBookingIntent()
      })
    },
    changeStateFlow(data) {
      window.scrollTo({top: 0, behavior: 'smooth'});
      data.token = this.token
      if (this.state == 'mm_submit' || this.state == 'matchMaking') {
        if (this.$store.getters.getIsLoggedIn) {
          this.therapists = null
          this.suggestDoctorsPending = true
          this.state = 'suggest_doctors'
        } else {
          this.state = 'auth'
        }
      } else if (data.state != 'matchMaking' && data.state != 'auth') {
        this.$emitEvent('setLoading', true)
        if (data.state == 'select_package') {

          this.SendEventTrk({
            event_id: 'journey_book_' + Date.now(),
            name: 'journey_book',
            email: this.profile.email,
            first_name: this.profile.firstname,
            last_name: this.profile.lastname,
            payload: {
              state: data.state,
            }
          })
        }
        this.requesting('setSession', 'changeState', {}, data).then((resp) => {
          if (data.state == 'select_time') {
            this.$emitEvent('setLoading', true)
            let localToken = localStorage.getItem('set_session_token')
            this.requesting('setSession', 'getFlowDetail', {}, {
              token: localToken
            }).then((resp) => {
              // User chose a therapist → select_time; track therapist_selection
              this.selectDoctor(resp.data.flow.doctor)
            }).catch((error) => {
              if (this.isFlowOwnershipMismatch(error) || (error.response && error.response.status === 400)) {
                this.recoverStaleJourney()
              }
            }).finally(() => {
              setTimeout(() => {
                this.$emitEvent('setLoading', false)
              }, 1000)
            })
          } else if (data.state == 'select_package') {
            // Wait 1 second before loading select package component
            setTimeout(() => {
              this.$nextTick(() => {
                if (this.selected_time) {
                  this.state = data.state
                } else {
                  // If selected_time is still not set, wait a bit more
                  setTimeout(() => {
                    this.state = data.state
                  }, 100)
                }
              })
            }, 1000)
          } else {
            this.state = data.state
          }

        }).finally(() => {
          setTimeout(() => {
            this.$emitEvent('setLoading', false)
          }, 1000)
        })
      } else {
        this.state = data.state
      }
    },
    setTherapists(therapists, options = {}) {
      const track = options.track !== false
      this.suggestDoctorsPending = false
      this.therapists = this.normalizeSuggestedDoctors(therapists)
      console.log('setted therapist', [this.therapists])
      if (track) {
        this.trackSuggestDoctorsResult()
      }
    },
    trackSuggestDoctorsResult() {
      if (this.journeySuggestResultTracked) return
      this.journeySuggestResultTracked = true

      if (this.showSuggestDoctorList) {
        this.sendJourneyTrkEvent('matchmaking_completed', {
          state: 'therapist_selection',
          therapist_count: this.therapists.length,
        })
      } else {
        this.sendJourneyTrkEvent('therapist_failed', {
          state: 'therapist_failed',
          therapist_count: 0,
        })
      }
    },
    sendJourneyTrkEvent(name, properties = {}) {
      if (!this.profile || typeof this.SendEventTrk !== 'function') return
      this.SendEventTrk({
        event_id: 'user_journey_' + Date.now(),
        name,
        email: this.profile.email,
        first_name: this.profile.firstname,
        last_name: this.profile.lastname,
        payload: properties,
      })
    },
    normalizeSuggestedDoctors(suggestedDoctorList) {
      if (!Array.isArray(suggestedDoctorList)) {
        return []
      }
      return suggestedDoctorList
          .map((item) => item?.doctor ?? item)
          .filter((doctor) => doctor && doctor.id)
    },
    getMatchTherapist() {
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 90)
      // this.match_additional_data = JSON.parse(localStorage.getItem('match_additional_data'))
      this.match_additional_data.token = localStorage.getItem('set_session_token')
      this.match_additional_data.timezone = this.timezone
      localStorage.removeItem('matchmaking_gender')
      delete this.match_additional_data.gender
      console.log(this.match_additional_data)
      if (this.profile.tz == 'UTC' || this.profile.tz != this.timezone) {
        let data = {
          timezone: this.timezone,
        };
        this.requesting('auth', 'editProfile', '', data)
      }

      if (this.match_additional_data) {
        this.state = 'suggest_doctors'
        this.therapists = null
        this.suggestDoctorsPending = true
        this.journeySuggestResultTracked = false
        this.requesting('match_making', 'suggestDoctor', {}, this.match_additional_data).then((resp) => {
          if (resp.message == "exclude") {
            this.suggestDoctorsPending = false
            this.$emitEvent('excludeUser')
          } else {
            setTimeout(() => {
              this.setTherapists(resp.data.therapists)
              this.state = 'suggest_doctors'
            }, 2000)
          }
        }).catch(() => {
          this.suggestDoctorsPending = false
        })
      }
    },
    isFlowOwnershipMismatch(error) {
      const status = error && error.response && error.response.status
      const payload = error && error.response && error.response.data
      const errorCode = payload && payload.data && payload.data.error_code
      return status === 403 || errorCode === 'FLOW_OWNERSHIP_MISMATCH'
    },
    clearJourneyStorage() {
      localStorage.removeItem('set_session_token')
      localStorage.removeItem('psychology_field_id')
      localStorage.removeItem('matchmaking_gender')
      localStorage.removeItem('match_additional_data')
    },
    recoverStaleJourney() {
      this.clearJourneyStorage()
      this.startFlow()
      this.state = 'matchMaking'
    },
    restartTest() {
      this.clearJourneyStorage()
      setTimeout(() => {
        location.reload();
      }, 500)
    },
    updateFlowState() {
      this.requesting('setSession', 'getFlowDetail', {}, {
        token: localStorage.getItem('set_session_token')
      }).then((resp) => {
        this.flow = resp.data.flow
      })
    },
    getFlowDetail(token) {
      this.$emitEvent('setLoading', true)

      this.requesting('setSession', 'getFlowDetail', {}, {
        token
      }).then((resp) => {
        let flow = resp.data.flow
        this.flow = flow
        this.initialAnswerRecord = resp.data.answer_record
        if (this.$route.query.from == 'googleAuth') {
          this.state = 'auth'
          setTimeout(() => {
            this.$emitEvent('needToCheckMobileAndSubmit')
          }, 300)
          return;
        }
        if (flow.is_expired) {
          console.log('expired')
          localStorage.removeItem('set_session_token')
          localStorage.removeItem('psychology_field_id')
          localStorage.removeItem('matchmaking_gender')
          localStorage.removeItem('match_additional_data')
          setTimeout(() => {
            location.reload();
          }, 500)
        } else if (flow.length == 0) {
          this.startFlow()
          this.state = 'matchMaking'
          return;
        }
        if (resp.data.test_status == 'done' && flow.state == 'init') {
          this.state = 'auth'
          return;
        }

        const therapists = this.normalizeSuggestedDoctors(flow.suggested_doctor)
        if (therapists.length) {
          this.setTherapists(therapists, { track: false })
        } else if (Array.isArray(flow.suggested_doctor)) {
          this.setTherapists([], { track: false })
        }

        if (flow.state == 'mm_submit') {
          this.state = 'matchMaking'
        } else if (flow.state == 'init') {
          this.state = 'matchMaking'
        } else if (flow.state == 'select_time') {
          this.state = flow.state
          this.selected_time = flow.date_time
          this.selectDoctor(flow.doctor, { track: false })
        } else if (flow.state == 'select_package' || flow.state == 'cart_submit') {
          this.selectTime(flow.date_time)
          this.selectDoctorForWithoutState(flow.doctor)
        } else if (flow.state == 'select_doctor') {
          // this.state = 'matchMaking'
          // this.currentStep = 4
          this.selectDoctor(flow.doctor, { track: false })
        } else {
          this.state = flow.state
        }

        this.applyBookingIntent()
      }).finally(() => {
        setTimeout(() => {
          this.$emitEvent('setLoading', false)
        }, 1000)
      }).catch((error) => {
        if (this.isFlowOwnershipMismatch(error)) {
          this.recoverStaleJourney()
          return
        }
        if (error.response && error.response.status === 400) {
          this.clearJourneyStorage()
          location.reload();
          return
        }
        console.error('Error:', error);
      });
    },
  },
  watch: {
    'state'() {
      if (this.historyNavigation) {
        return
      }
      this.pushJourneyHistory()
    },
    '$route.query.reffer_id'(val) {
      let id = val
      if (Array.isArray(id)) {
        id = id[0]
      }
      if (id != null && String(id).trim() !== '') {
        localStorage.setItem('reffer_id', String(id).trim())
      }
    }
  },
  mounted() {
    this.persistRefferIdFromQuery()
    this.pendingBookingIntent = parseBookingIntent(this.$route)

    if (!this.$store.getters.getIsLoggedIn) {
      const loginQuery = {afterLogin: 'userJourney'}
      const rid = localStorage.getItem('reffer_id')
      if (rid) {
        loginQuery.reffer_id = rid
      }
      if (shouldShowSimiaWelcome(this.$route)) {
        loginQuery.from = 'simia'
      }
      this.$router.push({name: 'login', params: {lang: 'fa'}, query: loginQuery})
      return;
    }

    if (shouldShowSimiaWelcome(this.$route)) {
      this.simiaWelcomeModal = true
    }

    window.history.replaceState({journeyStep: 'matchMaking'}, '', '?step=matchmaking')
    window.addEventListener('popstate', this.handlePopState)

    this.$onEvent('excludeUser', () => {
      this.state = 'exclude'
      this.suggestDoctorsPending = false
      localStorage.removeItem('set_session_token')
      localStorage.removeItem('match_additional_data')
      localStorage.removeItem('psychology_field_id')
      localStorage.removeItem('matchmaking_gender')
    })

    this.$onEvent('suggestDoctorsFetchEnd', () => {
      this.suggestDoctorsPending = false
    })


    this.timezone = this.prepareDefaultTimezone()


    this.$onEvent('changeVisibiltySeekback', (status) => {
      this.seekbarVisibility = status
    })

    this.$onEvent('goBack', () => {
      this.goBack()
    })

    this.$onEvent('setTherapists', (therapist) => {
      this.setTherapists(therapist)
    })


    let localToken = localStorage.getItem('set_session_token')
    if (localToken) {
      this.token = localToken
      this.getFlowDetail(localToken)
    } else {
      this.startFlow()
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState)
  }
}
</script>

<style>

@media (min-width: 200px) and (max-width: 800px) {
  .headerArea {
    padding: 0px 20px !important;
    box-shadow: none !important;
    height: 80px !important;;
  }

  .headerArea img {
    width: 58px !important;
  }

  .contextArea {
    background: #F6F9FC;

  }

  .titleLoading {
    font-size: 20px !important;
  }

  .descLoading {
    font-size: 16px !important;
  }

}

.nextBtn {
  height: 50px !important;
  color: white !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  border-radius: 8px;
}


.titleAuthModal {
  font-weight: 700;
  font-size: 18px;
  text-align: center;
}

.descAuthModal {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
}

.loginModal {
  padding: 25px 20px;
}

.journey-body {
  width: 100%;
}

.journey-progress-row {
  margin-top: 8px;
}

@media (min-width: 960px) {
  .journey-body {
    padding-top: 88px;
  }

  .journey-progress-row {
    margin-top: 16px;
    margin-bottom: 4px;
  }
}

.mobilecontext {
  background: #F6F9FC;
  height: 100%;
}


.footerArea {
  border-top: 1px solid #EAF0F6;
  background: #FFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}


.greenText {
  color: #39C990;
}

p[data-f-id="pbf"] {
  display: none !important;
}

.titleLoading {
  font-weight: 700;
  font-size: 24px;
  text-align: center;
}

.descLoading {
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
}

.noDoctorSection {
  background: white;
  border-radius: 18px;
  padding: 40px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.noDoctorSectionMobile {
  background: transparent;
  padding: 40px 20px;
}

.noDoctorIcon {
  opacity: 0.6;
}

.noDoctorTitle {
  font-size: 24px;
  font-weight: 700;
  color: #212121;
  line-height: 1.4;
}

.noDoctorDesc {
  font-size: 18px;
  font-weight: 500;
  color: #616161;
  line-height: 1.6;
  max-width: 500px;
  margin: 0 auto;
}

.startJourneyBtn {
  height: 50px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  border-radius: 8px;
  color: white !important;
  padding: 0 32px;
}

@media (max-width: 600px) {
  .noDoctorTitle {
    font-size: 20px;
  }

  .noDoctorDesc {
    font-size: 16px;
  }
}

</style>